"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var ImmutableAPI = _interopRequireWildcard(require("crm_data/api/ImmutableAPI"));

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = _interopRequireDefault(require("crm_data/meta/MetaProducers"));

var _ObjectTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectTypes"));

var _Raven = _interopRequireDefault(require("Raven"));

var _immutable = require("immutable");

var _q = _interopRequireDefault(require("q"));

var API_BASE = 'timeline/v2/';
var INTEGRATION_API = 'integrators/v1/portal-installs/apps-with-event-types';
var INSTALLED_HUBSPOT_OWNED_INTEGRATIONS_API = 'integrators/v1/portal-installs/hubspot-owned';
var TIMELINE_TIMEOUT = 5000;
var TIMELINE_ITEM_LIMIT = 15;

var uri = function uri(apiConfig) {
  var objectType = apiConfig.get('objectType');
  var objectId = apiConfig.get('objectId');
  return "" + API_BASE + objectType + "/" + objectId;
};

var getQuery = function getQuery(apiConfig) {
  var passEventTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var query = {
    timeout: TIMELINE_TIMEOUT,
    limit: passEventTypes ? apiConfig.get('TIMELINE_ITEM_LIMIT', TIMELINE_ITEM_LIMIT) : 5
  };

  if (passEventTypes) {
    query.t = apiConfig.get('eventOptions').toJS();
  }

  if (apiConfig.has('toDate')) {
    query.to = apiConfig.get('toDate');
  }

  if (apiConfig.has('fromDate')) {
    query.from = apiConfig.get('fromDate');
  }

  return query;
};

var parseTimelineResponse = function parseTimelineResponse(data) {
  var objectType = data.keySeq().first();

  if (_ObjectTypes.default.hasOwnProperty(objectType)) {
    return data.get(objectType).remove('defaultTimelineTypes');
  }

  return data.remove('defaultTimelineTypes');
};

function fetch(apiConfig) {
  return ImmutableAPI.get(uri(apiConfig), getQuery(apiConfig)).then(function (data) {
    // CRM-10769 - tmp fix, handle nextTimestamp === 0
    if (data.get('nextTimestamp') === 0) {
      return data.set('hasMore', false).remove('nextTimestamp');
    }

    return data;
  });
}

function fetchDefaults(apiConfig) {
  var fallback = function fallback() {
    return ImmutableAPI.get(uri(apiConfig) + "/default", getQuery(apiConfig, false));
  };

  var earlyTimelineRequest = window.quickFetch && window.quickFetch.getRequestStateByName('timeline');

  if (earlyTimelineRequest && !earlyTimelineRequest.eventsRetrieved) {
    return new _q.default.Promise(function (resolve, reject) {
      earlyTimelineRequest.whenFinished(function (response) {
        if (window.newrelic) {
          window.newrelic.setCustomAttribute('timelineEarlyRequest', 'succeeded');
        }

        earlyTimelineRequest.eventsRetrieved = true;
        resolve(parseTimelineResponse((0, _immutable.fromJS)(response)));
      });
      earlyTimelineRequest.onError(function (error) {
        _Raven.default.captureMessage('TimelineAPI: Timeline early requester failed', {
          extras: {
            error: error
          }
        });

        if (window.newrelic) {
          window.newrelic.setCustomAttribute('timelineEarlyRequest', 'failed');
        }

        earlyTimelineRequest.eventsRetrieved = true;
        reject((0, _immutable.Map)({
          events: (0, _immutable.List)(),
          nextTimestamp: new Date().valueOf(),
          failed: (0, _immutable.List)(),
          timedOut: (0, _immutable.List)(),
          hasMore: true
        }));
      });
    });
  }

  return (0, _MetaAPI.queueFetch)(_MetaProducers.default.MINKOWSKI, fallback, {}, parseTimelineResponse);
}

function fetchIntegrationEvents() {
  return ImmutableAPI.get(INTEGRATION_API);
}

function fetchInstalledHubSpotOwnedIntegrations() {
  return ImmutableAPI.get(INSTALLED_HUBSPOT_OWNED_INTEGRATIONS_API);
}

function fetchTimelineByUsersAndTeams(body) {
  var url = 'contacts/search/v1/search/engagements';
  return ImmutableAPI.post(url, body);
}

var _default = {
  fetch: fetch,
  fetchDefaults: fetchDefaults,
  fetchIntegrationEvents: fetchIntegrationEvents,
  fetchInstalledHubSpotOwnedIntegrations: fetchInstalledHubSpotOwnedIntegrations,
  fetchTimelineByUsersAndTeams: fetchTimelineByUsersAndTeams
};
exports.default = _default;
module.exports = exports.default;